import { FulfillmentProviderIds } from '../../enums/fulfillment-provider-ids';

const carrierLookupMap = {
  [FulfillmentProviderIds.Uber]: {
    phone: '1-866-987-3750',
    email: 'uberdirect@uber.com',
  },
};

export const getCarrierSupportContact = (carrierId) => {
  return carrierLookupMap[carrierId] || {};
};
